import {
  Select,
  Title,
  Paper,
  Stack,
  Button,
  Flex,
  Group,
  Divider,
  Text,
} from "@mantine/core";
import { useTranslation } from "react-i18next";
import useReportStore from "../../../store/useReportStore";
import useProfileStore from "../../../store/useProfileStore";
import { TrashCan } from "../../../shared/svg/TrashCan";

import { useState } from "react";
import ConfirmDelete from "../../../utils/components/ConfirmDelete";
import { OnboardingTour } from "@gfazioli/mantine-onboarding-tour";
import { useMediaQuery } from "@mantine/hooks";
import { getCurrencySymbol } from "../../../utils/helpers";
import { InfoTooltip } from "../../../shared/components/InfoTooltip";

export const ReportSelector = () => {
  const { t } = useTranslation();
  const { allReports, reportId, setReportId, deleteReport } = useReportStore();
  const { profileLanguage } = useProfileStore();
  const matches = useMediaQuery("(max-width: 650px)");

  const currentLanguage = Object.keys(profileLanguage ?? {})[0] ?? "en";
  const isEnglish = currentLanguage === "en";
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const options = allReports.map((report) => ({
    value: (isEnglish
      ? report.id
      : report.original_report ?? report.id
    ).toString(),
    label: report.report_name.replace(/_/g, " "),
  }));

  const selectedValue = reportId.toString();

  const handleDelete = async () => {
    try {
      const found = allReports.find((r) => r.id === reportId);
      const originalId = found?.original_report ?? reportId;
      const res = await deleteReport(originalId);
      if (res) {
        setIsDeleteOpen(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Paper withBorder radius="24px" p="32px" my="lg">
      <Stack gap="sm">
        <Title order={3}>{t("reports.title")}</Title>

        <Flex align="center" gap={matches ? 10 : 20} w="100%">
          <OnboardingTour.Target id="select-report">
            <div style={{ width: "100%" }}>
              <Select
                w="100%"
                data={options}
                value={selectedValue}
                onChange={(value) => {
                  if (!value) return;
                  setReportId(Number(value));
                }}
                nothingFoundMessage={t("reports.nothingFound")}
                clearable={false}
                placeholder={t("reports.placeholder")}
                size="md"
              />
            </div>
          </OnboardingTour.Target>
          <OnboardingTour.Target id="button-delete-report">
            <div>
              <Button
                variant="light"
                color="red"
                onClick={() => setIsDeleteOpen(true)}
                aria-label="Delete report"
              >
                <TrashCan />
              </Button>
            </div>
          </OnboardingTour.Target>
        </Flex>
      </Stack>

      <ConfirmDelete
        isOpen={isDeleteOpen}
        onClose={() => setIsDeleteOpen(false)}
        onDelete={handleDelete}
        title={t("delete_report_title")}
      />
    </Paper>
  );
};
